import "./contact.css";
import contactImg from "../assest/about_us.jpg";

function Contact() {
  return (
    <div className="contact-page">

      {/* ===================== BANNER ===================== */}
      <div className="about-banner">
        <img src={contactImg} alt="banner" className="banner-img" />
        <div className="banner-text">
          <h1>Contact Us</h1>
        </div>
      </div>
      <div className="body-container">
        <div className="bg-blobs"></div>
        <div className="bg-blobs2"></div>
        <div className="floating-dots"></div>
        {/* Contact Info Section */}
        <section className="container contact-info fade-in">
          <h2 className="section-heading text-center mb-4">
            <span className="line"></span>Get In Touch<span className="line"></span>
          </h2>
          <p className="contact-info-text text-center mb-5">
            Have questions? Our team is here to assist you.  
            Reach out through email, phone, or visit our office.
          </p>

          <div className="info-grid">
            <div className="info-box">
              <h3>Call Us</h3>
              <p>+91 9876543210</p>
            </div>

            <div className="info-box">
              <h3>Email</h3>
              <p>info@clickinformatics.com</p>
            </div>

            <div className="info-box">
              <h3>Address</h3>
              <p>109/415, Nehru Nagar, Jawahar Nagar, Kanpur, Uttar Pradesh 208012</p>
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="contact-form-section fade-in">
          <h2 className="section-heading text-center mb-4">
            <span className="line"></span>Send Us a Message<span className="line"></span>
          </h2>

          <form className="contact-form">
            <input type="text" placeholder="Your Name" required />
            <input type="email" placeholder="Email Address" required />
            <input type="text" placeholder="Phone Number" required />
            <textarea placeholder="Your Message" required></textarea>
            <button type="submit">Send Message</button>
          </form>
        </section>

        {/* Map Section */}
        <section className="map-section fade-in">
          <h2>Find Us on Map</h2>
          <iframe  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3571.4842699687733!2d80.322741!3d26.4723482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399c3880c0f59757%3A0x8c58f589caf61f4e!2sClick%20Informatics!5e0!3m2!1sen!2sin!4v1764935526507!5m2!1sen!2sin"  width="100%"  height="400"  style={{ border: 0 }}  allowFullScreen=""  loading="lazy"></iframe>

        </section>
      </div>
    </div>
  );
}

export default Contact;
